import { Box, Button, Flex, IconButton, TextField } from '@radix-ui/themes';
import React from 'react';
import { SearchIcon, ClearIcon } from 'shared/icons';

import './search-panel.css';

export function CandidatesSearchPanel({
   onSearchApply,
   onClear,
}: {
   onSearchApply: (v: string) => void;
   onClear: () => void;
}) {
   const [search, setSearch] = React.useState('');

   return (
      <Flex className="candidates-search-panel" justify="center">
         <Flex width={{ initial: '100%', sm: '540px' }} align="center" gap="1" px="6">
            <TextField.Root
               className="search-resume"
               size="3"
               color="blue"
               value={search}
               onChange={(e) => setSearch(e.target.value)}
               placeholder="Назва резюме або ключове слово"
            >
               {search && (
                  <TextField.Slot side="right">
                     <IconButton
                        size="3"
                        color="blue"
                        variant="ghost"
                        highContrast
                        onClick={() => {
                           setSearch('');
                           onClear();
                        }}
                     >
                        <ClearIcon width={18} height={18} />
                     </IconButton>
                  </TextField.Slot>
               )}
            </TextField.Root>

            <IconButton
               size="3"
               color="blue"
               variant="solid"
               highContrast
               onClick={() => {
                  onSearchApply(search);
               }}
            >
               <SearchIcon width={24} height={24} />
            </IconButton>
         </Flex>
      </Flex>
   );
}
